import React, { useEffect, useCallback, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import MuiDialogTitle from '@material-ui/core/DialogTitle'
import MuiDialogContent from '@material-ui/core/DialogContent'
import MuiDialogActions from '@material-ui/core/DialogActions'
import IconButton from '@material-ui/core/IconButton'
import CloseIcon from '@material-ui/icons/Close'
import Typography from '@material-ui/core/Typography'
import styled from 'styled-components'
import * as branchActions from '../../../redux/branches'

const DialogTitle = (props => {
  const { children, onClose, ...other } = props
  return (
    <Title disableTypography {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </Title>
  )
})

type StateProps = {
  branches: {
    branchLink: string;
  };
};

export default function BranchLinkDialog({ button }) {
  const { branchLink } = useSelector((state: StateProps) => state.branches);
  const dispatch = useDispatch()
  const [open, setOpen] = useState(false)

  useEffect(() => {
    if(branchLink) setOpen(true)
  }, [branchLink])

  const handleClose = useCallback(() => {
    setOpen(false)
    dispatch(branchActions.resetGenerateLink())
  }, [dispatch])

  const handleCopy = useCallback(() => {
    navigator.clipboard.writeText(branchLink)
  }, [branchLink])

  return (
    <>
      {button}
      <Dialog onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
        <DialogTitle id="customized-dialog-title" onClose={handleClose}>
          Generated Promotional Link
        </DialogTitle>
        <MuiDialogContent>
          <Typography gutterBottom color={'primary'} variant={'h4'} style={{ textAlign: 'center' }}>
            <img src={`https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=${branchLink}`} alt="Branch QR code"/>
            <div>{branchLink}</div>
          </Typography>
        </MuiDialogContent>
        <MuiDialogActions>
          <Button autoFocus onClick={handleCopy} color="primary">
            Copy
          </Button>
        </MuiDialogActions>
      </Dialog>
    </>
  )
}

const Title = styled(MuiDialogTitle)`
  justify-content: space-between;
  flex-direction: row;
  display: flex;
  align-items: center;
`
